import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nProvider } from '@nx/i18n';
import { SiteFooter } from '@nx/ui';
import { store } from './store/store';
import { ProtectedRoute } from './components/ProtectedRoute';
import { EORoleRoute } from './components/eo/EORoleRoute';
import { MarketingHome } from './pages/MarketingHome';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { Dashboard } from './pages/Dashboard';
import { EOLayout } from './pages/eo/EOLayout';
import { EventsListPage } from './pages/eo/EventsListPage';
import { EventFormPage } from './pages/eo/EventFormPage';
import { AgendaPage } from './pages/eo/AgendaPage';
import { PublicAgendaPage } from './pages/eo/PublicAgendaPage';
import { ParticipantsPage } from './pages/eo/ParticipantsPage';
import { ParticipantImportPage } from './pages/eo/ParticipantImportPage';
import { PosterEditorPage } from './pages/eo/PosterEditorPage';
import { PartnersListPage } from './pages/eo/PartnersListPage';
import { PartnerDetailPage } from './pages/eo/PartnerDetailPage';
import { ChecklistPage } from './pages/eo/ChecklistPage';
import { AuthAction } from './pages/AuthAction';
import { VerifyEmail } from './pages/VerifyEmail';
import { RegistrationLandingPage } from './pages/eo/RegistrationLandingPage';
import { ProfileEditorPage } from './pages/profile/ProfileEditorPage';
import { PublicProfilePage } from './pages/profile/PublicProfilePage';
import { PreviewProfilePage } from './pages/profile/PreviewProfilePage';
import { DiscoverPage } from './pages/profile/DiscoverPage';
import { AppErrorBoundary } from './components/AppErrorBoundary';

function AppShell() {
  const location = useLocation();
  const hideFooter =
    location.pathname.startsWith('/eo') ||
    location.pathname.startsWith('/p/') ||
    location.pathname.startsWith('/u/') ||
    location.pathname.startsWith('/register/') ||
    location.pathname.startsWith('/profile') ||
    location.pathname.startsWith('/preview/');

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<MarketingHome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/auth/action" element={<AuthAction />} />
          <Route path="/p/:token" element={<PublicAgendaPage />} />
          <Route path="/register/:eventId" element={<RegistrationLandingPage />} />
          <Route path="/u/:slug" element={<PublicProfilePage />} />
          <Route path="/preview/:token" element={<PreviewProfilePage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<ProfileEditorPage />} />
          </Route>
          <Route element={<EORoleRoute />}>
            <Route element={<EOLayout />}>
              <Route path="/eo/events" element={<EventsListPage />} />
              <Route path="/eo/events/new" element={<EventFormPage />} />
              <Route path="/eo/events/:eventId/agenda" element={<AgendaPage />} />
              <Route path="/eo/events/:eventId/participants" element={<ParticipantsPage />} />
              <Route path="/eo/events/:eventId/participants/import" element={<ParticipantImportPage />} />
              <Route path="/eo/events/:eventId/poster" element={<PosterEditorPage />} />
              <Route path="/eo/events/:eventId/partners" element={<PartnersListPage />} />
              <Route path="/eo/events/:eventId/partners/:partnerId" element={<PartnerDetailPage />} />
              <Route path="/eo/events/:eventId/checklist" element={<ChecklistPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      {!hideFooter ? <SiteFooter /> : null}
    </div>
  );
}

export function App() {
  return (
    <Provider store={store}>
      <I18nProvider>
        <AppErrorBoundary>
          <BrowserRouter>
            <AppShell />
          </BrowserRouter>
        </AppErrorBoundary>
      </I18nProvider>
    </Provider>
  );
}
